module.exports = __webpack_public_path__ + "static/media/eye.eabe398a.svg";